import { useTranslation } from "react-i18next";

// external module
import { useRef, useState } from "react";
import { useRecoilValue } from "recoil";

// internal module
import { appBackgroundColorState } from "store/recoil/@common/appBackgroundColorState";

// hooks
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "store/redux/modules";

// state
import { useRecoilState } from "recoil";
import { pageTitleState } from "store/recoil/@common/pageTitleState";
import { setNavTab } from "store/redux/modules/status";

// styles & assets
import { SvgHome2, SvgLeft, SvgMenu, SvgWithbecon } from "assets/svg/Icon";
import classNames from "classnames/bind";
import styles from "./Header.module.scss";
import "./Header.scss";
import { scannerState } from "bridge/store/scannerState";
import { getScannerStatusImage } from "utils/(assets)";
import { useScalpShooting } from "bridge/hooks/(useScalpShotting)";
import { getUserId, getUserName } from "store/redux/modules/user";
import { useCheckScannerModal } from "modules/bridge/components/CheckScannerModal";
import { path } from "utils/(path)";

const cn = classNames.bind(styles);

export default function Header() {
  const { inIframe, accountInfo } = useAppSelector(({ status, account }) => ({
    inIframe: status.inIframe,
    accountInfo: account.account,
  }));
  const userId = useAppSelector(getUserId);
  const userNickname = useAppSelector(getUserName);
  const isScannerConnected = useRecoilValue(scannerState)?.connectStatus === "complete";
  const { openModal: openCheckScannerModal } = useCheckScannerModal();
  const scannerImg = getScannerStatusImage(isScannerConnected);
  const [pageTitle, setPageTitle] = useRecoilState(pageTitleState);
  const [pathChanged, setPathChanged] = useState(false);
  const { scalpShooting } = useScalpShooting();

  // const appBackgroundColor = useRecoilValue(appBackgroundColorState);

  // =================== hooks =================== //
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isShowIcon = !(location.pathname.includes(path.auth()) || location.pathname.includes("/drawer"));

  // const isMainPage = location.pathname === "/" || location.pathname === "/community" || location.pathname === "/drawer";
  const handleCheckScanner = () => {
    if (isScannerConnected) {
      openCheckScannerModal();
    } else {
      scalpShooting({
        userId,
        userNickname,
        currentAction: "DevicePairingBluetooth",
      });
    }
  };

  const usePrevious = (value: any) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };
  const prevPathname = usePrevious(location.pathname);
  useEffect(() => {
    if (prevPathname !== location.pathname) setPathChanged(true);
  }, [location.pathname, prevPathname]);
  useEffect(() => {
    if (pathChanged) {
      const timer = setTimeout(() => {
        setPathChanged(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [pathChanged]);

  // =================== func =================== //

  const onPrevBtnClick = () => {
    navigate(-1);
  };

  if (location.pathname === "/intro") return null;
  return (
    <header className={`${cn("wrapper-header")} header`}>
      <div className={`${cn("container-header")} container-header`}>
        {location.pathname === "/" ? (
          <div
            className={`${cn("logo", { inIframe: inIframe })} logo`}
            onClick={() => {
              navigate("/");
              dispatch(setNavTab(0));
            }}
          >
            <SvgWithbecon />
          </div>
        ) : (
          <div className={cn("area-pageTitle")}>
            <div
              className={cn("goBack", { animate: pathChanged })}
              onClick={onPrevBtnClick}
              style={{
                display: inIframe && location.pathname === "/" ? "none" : "block",
              }}
            >
              <SvgLeft />
            </div>

            <div className={cn("title", "font_bold", { animate: pathChanged })}>{pageTitle}</div>
          </div>
        )}

        <div className={cn("wrap-navFeat")}>
          {isShowIcon && (
            <>
              <div
                className="my-btn-etc w-fs-2xl"
                onClick={() => {
                  handleCheckScanner();
                }}
              >
                <img src={scannerImg} alt="scanner" />
              </div>
              <div
                className={cn("hamburger")}
                onClick={() => {
                  if (accountInfo) navigate("/drawer");
                }}
              >
                <SvgMenu />
              </div>
            </>
          )}

          {/* {!isMainPage && (
            <div className={cn("home", { inIframe: inIframe })} onClick={() => navigate("/")}>
              <SvgHome2 />
            </div>
          )} */}
        </div>
      </div>
    </header>
  );
}
